import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "w-full flex items-center justify-end space-x-3" }
const _hoisted_4 = { href: "/settings/notifications/index" }

import { ref } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: true,
    backLink: "/settings/notifications/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", _hoisted_4, [
                  _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(ButtonComponent, {
                  btnWidth: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(ConfirmationModal, {
                typeTwo: true,
                show: showConfirmation.value,
                onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
                onConfirm: _cache[2] || (_cache[2] = ($event: any) => {showSuccess.value = true; showConfirmation.value = false}),
                "cancel-text": "Cancel",
                "action-text": "Confirm",
                title: "Save Record",
                content: "Are you sure you wish to save this record?"
              }, null, 8, ["show"]),
              _createVNode(SuccessModal, {
                show: showSuccess.value,
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
                "action-text": "Close",
                title: "Record Updated!",
                content: "Data has been successfully updated"
              }, null, 8, ["show"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})